<template>
  <div class="overheid">
    <div class="container">
      <FlowchartWithContent
        type="overheid"
        :json="json"
      />
    </div>
  </div>
</template>

<script>
import json from '@/../static/flow.json'
import { FlowchartWithContent } from '@/components/Flow'

export default {
  name: 'Overheid',
  data () {
    return {
      json: [{}]
    }
  },
  created () {
    this.json = json.overheid
  },
  components: {
    FlowchartWithContent
  }
}
</script>

<style lang="scss" scoped>
  .overheid {
    
  }
</style>



// WEBPACK FOOTER //
// src/domains/Overheid.vue